import { render, staticRenderFns } from "./epb-list.component.vue?vue&type=template&id=0a3955f4&scoped=true"
import script from "./epb-list.component.vue?vue&type=script&lang=ts"
export * from "./epb-list.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-list.component.vue?vue&type=style&index=0&id=0a3955f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3955f4",
  null
  
)

export default component.exports